export default __webpack_public_path__ + "static/media/termsAndConditions_root_background.db4ae1d3.jpg";